// @flow
import merge from 'lodash/merge';
import type { EnvironmentConfig } from 'model/EnvironmentConfig';
import staging from 'appconfig/envs/staging';

export default (): EnvironmentConfig =>
  merge(staging(), {
    clicktaleEnabled: false,
    hamsUrl: 'http://hamlet.bizbox.atlassian.com:8888',
    idLoginUrl: 'http://auth.bizbox.atlassian.com:8888',
    logoutUrl: () =>
      `http://auth.bizbox.atlassian.com:8888/?continue=${encodeURIComponent(
        document.location.href,
      )}`,
    i18nUrl: 'https://cart-static.ap-southeast-2.dev.public.atl-paas.net/i18n',
    sentry: {
      environment: 'local',
    },
    root: 'http://localhost:3000/purchase',
  });
